import { GenericService } from "./Generic.service";

export class ExamService extends GenericService<string> {
  readonly URI: string = "Exame";

  constructor() {
    super();
    this.setUri(this.URI);
  }

  public async getAll(parms?: string) {
    return await super.getByResource("", {Text: parms, PageSize: 5000 });
  }

  public async getById(id: string) {
    return await super.getByResource(`${id}`, {
      PageSize: 500,
    });
  }

}
